import { ITransaction } from "../../../../config/transactions";

interface INotesProps {
    value: string;
    transaction: ITransaction;
}

export const Notes = ({value, transaction}: INotesProps) => <div dangerouslySetInnerHTML={{__html: `${value.replace(/\n/g, '<br />')}`}} />;
